export const en = {
  title: 'Wind Speed Potential',
  subtitle: '1 km, global, DTU/World Bank Group/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Function',
      value: 'Mean wind speed for any location on Earth',
    },
    {
      label: 'Resolution',
      value: '1 km',
    },
    {
      label: 'Geographic coverage',
      value: 'Global',
    },
    {
      label: 'Source',
      value: '\tDTU/World Bank Group/ESMAP',
    },
    {
      label: 'Frequency',
      value: '',
    },
    {
      label: 'Date of content',
      value: '',
    },
    {
      label: 'Cautions',
      value:
        'The GWA uses two major modeling components that can introduce uncertainty into the calculations. These components are the mesoscale modeling and the microscale modeling.',
    },
    {
      label: 'License',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'Overview',
    value:
      'The Global Wind Atlas (GWA) mean wind speed dataset was generated by the Department of Wind Energy at the Technical University of Denmark (DTU), World Bank Group and Energy Sector Management Assistance Program (ESMAP).\n\nMean wind speed is one of the key performance indicators of wind energy production. GWA starts with low resolution wind speed data and converts it to high resolution data using a downscaling process. The result of this process is a model of local wind climates over the globe (except the North and South Poles and far offshore ocean areas) at 1 kilometer resolution for three heights: 50 meters, 100 meters and 200 meters.',
  },
  citation: {
    label: 'Citation',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
